import { observer } from 'mobx-react-lite';
import { SubstrateSearchSuggestionSegment } from 'owa-search-service';
import * as React from 'react';
import highlightDisplayText, { dehighlightDisplayText } from '../utils/highlightDisplayText';

const searchBoxPillWellStyles = require('./SearchBoxPillWell.scss');
const suggestionStyles = require('./suggestionsCallout/SearchSuggestion.scss');

export interface TextSuggestionSegmentProps {
    segment: SubstrateSearchSuggestionSegment;
}

const TextSuggestionSegment = observer(function TextSuggestionSegment(
    props: TextSuggestionSegmentProps
) {
    const { segment } = props;
    const highlightTextRegions = highlightDisplayText(segment.DisplayText);

    return (
        <div
            className={searchBoxPillWellStyles.segmentName}
            title={dehighlightDisplayText(segment.DisplayText)}>
            {highlightTextRegions
                .filter(e => e.text.length > 0)
                .map((e, i) => {
                    const className = e.isHighlighted
                        ? suggestionStyles.keywordMatchSuggestion
                        : suggestionStyles.keywordNonMatchSuggestion;
                    return (
                        <div className={className} key={i}>
                            {e.text}
                        </div>
                    );
                })}
        </div>
    );
});
export default TextSuggestionSegment;
